module.exports = __webpack_public_path__ + "img/tsaruk.8a632eeb.jpg";